import toast from 'react-hot-toast';
import { supabase } from '../../lib/supabase';

async function invokeFunction(name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) throw error;
  if (data?.error) {
    const err = new Error(data.message || data.error);
    err.code = data.error;
    err.conflict = data.conflict;
    throw err;
  }
  return data;
}

export function useMatching() {
  const matchRecord = async (incomingRecordId, clientId, force = false) => {
    return invokeFunction('match-incoming-record', {
      incoming_record_id: incomingRecordId,
      client_id: clientId,
      force,
    });
  };

  const unmatchRecord = async (incomingRecordId) => {
    return invokeFunction('unmatch-incoming-record', { incoming_record_id: incomingRecordId });
  };

  const ignoreRecord = async (incomingRecordId) => {
    return invokeFunction('ignore-incoming-record', { incoming_record_id: incomingRecordId });
  };

  const createDormantAccount = async ({ email, name, incomingRecordId, sendInvite = false }) => {
    return invokeFunction('create-dormant-account', {
      email,
      name,
      incoming_record_id: incomingRecordId,
      send_invite: sendInvite,
    });
  };

  const importNwraRecords = async (records) => {
    return invokeFunction('import-nwra-records', { records });
  };

  const syncNwraStatus = async (clientId) => {
    return invokeFunction('sync-nwra-status', { client_id: clientId });
  };

  const runWithToast = async (label, fn) => {
    try {
      const result = await fn();
      toast.success(label);
      return result;
    } catch (err) {
      if (err.code === 'identity_conflict') {
        toast.error(err.message || 'Identity conflict — resolve before matching.');
      } else {
        toast.error(err.message || 'Action failed');
      }
      throw err;
    }
  };

  return {
    matchRecord,
    unmatchRecord,
    ignoreRecord,
    createDormantAccount,
    importNwraRecords,
    syncNwraStatus,
    runWithToast,
  };
}
